module.exports = __webpack_public_path__ + "static/Dulux Logo-47af09de910255ec6a57354478cdf461.png";